module.exports = __webpack_public_path__ + "static/fj-74e854d93bafbccd9d318c113e70f313.svg";